import stickySummary from './sticky-summary';
import signatureRequest from './signature-request';
import AdditionalPayments from './additional-payments';
import CartPageDiscount from '../../components/cart-discount/cart-page-discount';
import Gift from '../loyalty/gift';
import initInstallmentsModal from '../../components/modals/installments-modal';

export default () => {
  if (!$('.cart-section').length) {
    return;
  }

  new Gift();
  signatureRequest();
  stickySummary();
  new AdditionalPayments();
  new CartPageDiscount();
  initInstallmentsModal();
};
